module.exports = __webpack_public_path__ + "img/coldway-header.6035a4c1.jpg";